import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import EmailCapture from '../components/EmailCapture';

const Home = () => {
  return (
    <div className="pt-16">
      <Hero />
      <Features />
      <EmailCapture />
    </div>
  );
};

export default Home;